module.exports = __webpack_public_path__ + "img/hero-home.6046ff17.jpg";